var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "gt-md" },
      _vm._l(_vm.items, function(item, index) {
        return _vm.isUser || !item.restricted
          ? _c(
              "q-btn",
              {
                key: index,
                staticClass: "text-grey-8 q-mr-sm",
                attrs: {
                  icon: item.icon,
                  flat: "",
                  dense: item.icon !== undefined
                },
                on: { click: item.action }
              },
              [
                item.icon === undefined
                  ? [
                      _vm._v(
                        "\n        " + _vm._s(_vm.$t(item.text)) + "\n      "
                      )
                    ]
                  : _c("q-tooltip", [
                      _vm._v(
                        "\n        " + _vm._s(_vm.$t(item.text)) + "\n      "
                      )
                    ])
              ],
              2
            )
          : _vm._e()
      })
    ),
    _c(
      "div",
      { staticClass: "lt-lg" },
      [
        _c(
          "q-btn",
          { attrs: { flat: "", icon: "more_vert" } },
          [
            _c(
              "q-popover",
              [
                _c(
                  "q-list",
                  { attrs: { link: "" } },
                  _vm._l(_vm.items, function(item) {
                    return _vm.isUser || !item.restricted
                      ? _c(
                          "q-item",
                          {
                            directives: [
                              {
                                name: "close-overlay",
                                rawName: "v-close-overlay"
                              }
                            ],
                            key: item.text,
                            staticClass: "text-grey-8",
                            nativeOn: {
                              click: function($event) {
                                return item.action($event)
                              }
                            }
                          },
                          [
                            _c("q-item-side", {
                              attrs: { left: "", icon: item.icon }
                            }),
                            _c("q-item-main", [
                              _c("span", [_vm._v(_vm._s(_vm.$t(item.text)))])
                            ])
                          ],
                          1
                        )
                      : _vm._e()
                  })
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }